export const styles = {
    messageWrapper: {
        flex: 1,
    },
};
